import React, { useState } from 'react';
import { IconButton, Tooltip, Box, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { Add, Edit, Delete, Warning } from '@mui/icons-material';

interface CalendarHoverToolbarProps {
    onAdd: (event: React.MouseEvent<HTMLElement>) => void;
    onEdit: () => void;
    onCancel: () => void;
    advancedMode?: boolean;
    reservationName?: string;
}

const CalendarHoverToolbar: React.FC<CalendarHoverToolbarProps> = ({
    onAdd,
    onEdit,
    onCancel,
    advancedMode = false,
    reservationName
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const [confirmOpen, setConfirmOpen] = useState(false);

    const handleCancelClick = () => {
        if (advancedMode) {
            setConfirmOpen(true);
        }
    };

    const handleConfirmCancel = () => {
        onCancel();
        setConfirmOpen(false);
    };

    return (
        <>
            <Box
                sx={{
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    display: 'flex',
                    gap: 0.5,
                    background: isDark ? 'rgba(40,40,40,0.95)' : 'rgba(255,255,255,0.9)',
                    borderRadius: 1,
                    p: 0.2,
                    zIndex: 10,
                    boxShadow: 1,
                }}
            >
                <Tooltip title="Agregar reserva">
                    <IconButton size="small" onClick={onAdd} sx={{ color: '#4caf50' }}>
                        <Add fontSize="small" />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Ver detalle">
                    <IconButton size="small" onClick={onEdit} sx={{ color: '#2196f3' }}>
                        <Edit fontSize="small" />
                    </IconButton>
                </Tooltip>
                {advancedMode && (
                    <Tooltip title="Cancelar reserva">
                        <IconButton size="small" onClick={handleCancelClick} sx={{ color: '#f44336' }}>
                            <Delete fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>

            <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'warning.main' }}>
                    <Warning /> Confirmar cancelación
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        {reservationName
                            ? `¿Cancelar la reserva de ${reservationName}?`
                            : '¿Cancelar esta reserva? Esta acción no se puede deshacer.'}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)}>No, mantener</Button>
                    <Button onClick={handleConfirmCancel} color="error" variant="contained">
                        Sí, cancelar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CalendarHoverToolbar;
